import React, { useState, useRef, useEffect } from "react";

interface MultiCheckboxProps {
  items: { id: number; name: string }[];
  selectedIds: number[];
  displayRveresed?: boolean;
  onChange: (selectedIds: number[]) => void;
}

const MultiCheckbox: React.FC<MultiCheckboxProps> = ({
  items,
  selectedIds,
  displayRveresed,
  onChange,
}) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Состояние выпадающего списка
  const [searchQuery, setSearchQuery] = useState(""); // Поисковый запрос
  const dropdownRef = useRef<HTMLDivElement>(null); // Ref для выпадающего списка

  // Обработчик изменения состояния чекбокса
  const handleCheckboxChange = (id: number) => {
    const newSelectedIds = selectedIds.includes(id)
      ? selectedIds.filter((selectedId) => selectedId !== id)
      : [...selectedIds, id];
    onChange(newSelectedIds);
  };

  // Фильтрация элементов по поисковому запросу
  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Закрытие выпадающего списка по клику за его пределами
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Получение выбранных элементов
  const selectedItems = items.filter((item) => selectedIds.includes(item.id));

  return (
    <div className="multi-checkbox" ref={dropdownRef}>
      {/* Поле для отображения выбранных элементов или строки поиска */}
      <div
        className="selected-items"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {selectedItems.length > 0 ? (
          selectedItems.map((item) => (
            <span key={item.id} className="selected-item">
              {item.name}
            </span>
          ))
        ) : (
          <span className="placeholder">Выберите</span>
        )}
      </div>

      {/* Выпадающий список */}
      {isDropdownOpen && (
        <div className={`dropdown${displayRveresed? " reversed": ""}`}>
          {/* Поле для поиска */}
          <input
            type="text"
            placeholder="Поиск..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />

          {/* Список элементов */}
          <div className="dropdown-list">
            {filteredItems.map((item) => (
              <div key={item.id} className="dropdown-item">
                <label>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                  {item.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiCheckbox;